// Text-only notes card for the calendar sidebar "phone" preview (formType 'TextOnly').
// Copy of the workouts module's WorkoutNotes — already display-only.
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { BoxShadow } from '../../../../shared/GlobalStyles';

const NoteBox = styled('div')`
  display: flex;
  margin-bottom: 25px;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${BoxShadow};
  flex-direction: column;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  white-space: pre-wrap;
  font-size: 12px;
  font-family: 'Nunito Sans';
  text-align: center;
`;

const CalendarWorkoutNotes = ({ workoutObject }) => (
  <NoteBox>{workoutObject.text}</NoteBox>
);

CalendarWorkoutNotes.propTypes = {
  workoutObject: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarWorkoutNotes;
